import type BaseEnumType from "@/app/services/baseEnumType";

export class EnumVesselSummaryView implements BaseEnumType {
  private static allValues: EnumVesselSummaryView[] = []; // make sure this is top-most

  public static standard = new EnumVesselSummaryView(
    0,
    "standard",
    "enum_vessel_summary_view_standard"
  );

  public static compact = new EnumVesselSummaryView(
    1,
    "compact",
    "enum_vessel_summary_view_compact"
  );

  public static list = new EnumVesselSummaryView(
    2,
    "list",
    "enum_vessel_summary_view_list"
  );

  public key: number;
  public value: string;
  public translationKey?: string;

  private constructor(key: number, value: string, translationKey?: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumVesselSummaryView.allValues.push(this);
  }

  public static getValues(): EnumVesselSummaryView[] {
    return EnumVesselSummaryView.allValues;
  }

  public static getByKey(key: number): EnumVesselSummaryView {
    const found = EnumVesselSummaryView.allValues.find((e) => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumVesselSummaryView - Key not found: ${key}`);
    }

    return found;
  }
}
